import { render, staticRenderFns } from "./IntegrationsComponent.vue?vue&type=template&id=a3a94bd4&scoped=true&"
import script from "./IntegrationsComponent.vue?vue&type=script&lang=js&"
export * from "./IntegrationsComponent.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationsComponent.vue?vue&type=style&index=0&id=a3a94bd4&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3a94bd4",
  null
  
)

export default component.exports